import { render, staticRenderFns } from "./industrygroupsTemp.vue?vue&type=template&id=f17d37b0&"
import script from "./industrygroupsTemp.vue?vue&type=script&lang=js&"
export * from "./industrygroupsTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports